import React from "react"
import { ThemeProvider } from "./landing/ThemeProvider"
import { LangProvider } from "./landing/i18n/LangContext"
import { SiteNav } from "./landing/SiteNav"
import { HeroSection } from "./landing/HeroSection"
import { StatsSection } from "./landing/StatsSection"
import { FeaturesSection } from "./landing/FeaturesSection"
import { FinalCta } from "./landing/FinalCta"
import { SiteFooter } from "./landing/SiteFooter"

export default function App() {
  return (
    <ThemeProvider>
      <LangProvider>
        <div className="min-h-screen bg-white dark:bg-gray-950 antialiased">
          <SiteNav />
          <main>
            <HeroSection />
            <StatsSection />
            <FeaturesSection />
            <FinalCta />
          </main>
          <SiteFooter />
        </div>
      </LangProvider>
    </ThemeProvider>
  )
}
